(function () {
  'use strict';

  /**
   * Math trunc polyfill
   */
  if (!Math.trunc) {
    Math.trunc = trunc;
  }

  if (!Math.round10) {
    Math.round10 = function (value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }

  if (!Math.floor10) {
    Math.floor10 = function (value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }

  if (!Math.ceil10) {
    Math.ceil10 = function (value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }

  if (!RegExp.escape) {
    RegExp.escape = function escapeRegExp(text) {
      return text && text.replace ? text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') : text;
    };
  }

  /**
   * Custom Event constructor polyfill
   */
  if (typeof window.CustomEvent !== 'function') {
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
  }

  /**
   *
   * @param {number} num Number
   * @return {number} Corrected value
   */
  function trunc(num) {
    return num > 0 ? Math.floor(num) : Math.ceil(num);
  }

  /**
   * @description Correction of rounding of decimals
   *
   * @param {String}  type  Correction type
   * @param {Number}  value Number.
   * @param {Integer} exp   pow.
   * @returns {Number} Corrected value.
   */
  function decimalAdjust(type, value, exp) {
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;

    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }

    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));

    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
  }

  /**
   *
   * @param event
   * @param params
   * @returns {Event}
   * @constructor
   */
  function CustomEvent(event, params) {
    const evt = document.createEvent('CustomEvent');
    // eslint-disable-next-line no-param-reassign
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  Number.isInteger =
    Number.isInteger ||
    function (value) {
      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };

  Number.isFinite =
    Number.isFinite ||
    function (value) {
      return typeof value === 'number' && isFinite(value);
    };

  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
      value: function assign(target, varArgs) {
        // .length of function is 2
        'use strict';
        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        const to = Object(target);

        for (let index = 1; index < arguments.length; index++) {
          const nextSource = arguments[index];

          if (nextSource != null) {
            // Skip over if undefined or null
            for (let nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true,
    });
  }

  // For IE
  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
})();
